







































































import { computed, defineComponent, getCurrentInstance, onMounted, ref, toRefs, watch } from '@vue/composition-api';
import lottie from 'lottie-web';
import i18n, { i18n_t } from '@/locales/i18n';
import { httpUrl } from '@/renderer/scripts/http';
import phonePrefixOptions from '@/renderer/scripts/utils/phonePrefix';
import { phonePrefixFilter } from '@/renderer/common/phoneUtils';
import { dispatchRouter } from '@/renderer/scripts/utils/tools/dispatchRouter';
import userValidator, { validatePhoneNumber } from '@/renderer/components/user/compositions/userValidator';
export default defineComponent({
  name: 'sendSMSRegister',
  props: {
    form: {
      type: Object,
      required: true,
      default: {},
    },
    errMsg: {
      type: String,
      required: true,
      default: '',
    },
    phoneMaxLen: {
      type: Number,
      required: true,
      default: 11,
    },
    methods: {
      type: Object,
      required: true,
      default: {},
    },
  },
  setup(props, context) {
    const vm = getCurrentInstance()?.proxy || context.root;
    const store = vm.$store;
    const showAnimation = ref(false);
    const innerErrMsg = computed({
      get() {
        return props.errMsg;
      },
      set(val) {
        context.emit('update:errMsg', val);
      },
    });
    const introduces = [
      {
        title: i18n_t('企业空间'),
        desc: i18n_t('数据资料沉淀，离职数据不丢失'),
        position: 'left-top',
      },
      {
        title: i18n_t('误删恢复'),
        desc: i18n_t('被误删的文档，也可以恢复找回'),
        position: 'left-bottom',
      },
      {
        title: i18n_t('协作空间'),
        desc: i18n_t('办公资料跨设备无缝传输与同步'),
        position: 'right-top',
      },
      {
        title: i18n_t('安全外链'),
        desc: i18n_t('交付方案，指定的人才能查看'),
        position: 'right-bottom',
      },
    ];
    const { form: formData } = toRefs(props);
    const { methods: registerMethods } = props;
    const { rules } = userValidator(formData.value);
    const phoneIsCorrect = ref(false);
    // 渲染动画 & 错误兜底处理
    const drawAnimationWrapper = () => {
      const animationWrapper: Element = document.querySelector('.welcome__show-diagram') as Element;
      const path = `${httpUrl.staticCDNUrl}/tools/images/guideAnimation/welcome/data.json`;
      const animation = lottie.loadAnimation({
        container: animationWrapper,
        renderer: 'svg',
        loop: true,
        autoplay: true,
        path,
      });
      animation.addEventListener('data_ready', () => {
        showAnimation.value = true;
        animation.removeEventListener('data_ready');
      });
      animation.addEventListener('data_failed', () => {
        showAnimation.value = false;
        animation.removeEventListener('data_failed');
      });
    };
    const methods = {
      goLogin() {
        dispatchRouter(
          {
            name: 'login',
          },
          'replace',
        );
      },
    };
    watch([() => formData.value.code, () => formData.value.phoneNumber], () => {
      phoneIsCorrect.value = validatePhoneNumber(formData.value.code, formData.value.phoneNumber);
      innerErrMsg.value = '';
    });
    onMounted(() => {
      drawAnimationWrapper();
      registerMethods.initCaptcha();
    });
    return {
      introduces,
      showAnimation,
      formData,
      rules,
      innerErrMsg,
      phoneIsCorrect,
      phonePrefixOptions,
      phonePrefixFilter,
      ...methods,
      ...registerMethods,
    };
  },
});
